import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '../../../action/ActionArgs'
import type { IAction } from '../../../action/IAction'
import { Coupon } from '../Coupon'

@InputType()
export class ValidateCouponArgs extends ActionArgs {
  @Field(() => String)
  code: string

  /** Purchase amount (before discount) the coupon is validated against — checked against `minPurchaseAmount` and used to compute `discountAmount`. */
  @Field(() => Float)
  amount: number

  /**
   * Whose redemption count this validates against — defaults to the caller when omitted, which
   * is correct for the mobile pre-check (always checking against itself). `CreateCreditPurchase`
   * always supplies the resolved purchase owner explicitly, so an admin-buys-for-another-user
   * check agrees with whose redemption `SettleCreditPurchase` later records.
   */
  @Field(() => String, { nullable: true })
  ownerId?: string
}

@ObjectType()
@InputType('ValidateCouponResultInput')
export class ValidateCouponResult {
  @Field(() => Coupon)
  coupon: Coupon

  /** Amount deducted from `amount`, clamped so it never exceeds `amount`. */
  @Field(() => Float)
  discountAmount: number

  /** `amount - discountAmount`, clamped to a minimum of 0. */
  @Field(() => Float)
  finalAmount: number
}

export interface IValidateCoupon extends IAction<ValidateCouponResult, ValidateCouponArgs> {}
